import { render, staticRenderFns } from "./image-list.vue?vue&type=template&id=476ef070&scoped=true"
import script from "./image-list.vue?vue&type=script&lang=js"
export * from "./image-list.vue?vue&type=script&lang=js"
import style0 from "./image-list.vue?vue&type=style&index=0&id=476ef070&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ef070",
  null
  
)

export default component.exports